import { ReactNode } from "react";
import { SubNav, SubNavTab } from "@/components/layout/SubNav";

interface TitleFolderLayoutProps {
  children: ReactNode;
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

const titleFolderTabs: SubNavTab[] = [
  { label: "Audit Dashboard", path: "/title-folders/dashboard" },
  { label: "Title Folders", path: "/title-folders/browse" },
  { label: "Orphan Folders", path: "/title-folders/orphans" },
];

export const TitleFolderLayout = ({ children, onRefresh, isRefreshing }: TitleFolderLayoutProps) => {
  return (
    <div className="flex flex-col h-full">
      <SubNav tabs={titleFolderTabs} onRefresh={onRefresh} isRefreshing={isRefreshing} />
      <main className="flex-1 overflow-y-auto bg-gradient-to-br from-slate-50 via-stone-50 to-zinc-100 dark:from-slate-950 dark:via-stone-950 dark:to-zinc-900">
        {children}
      </main>
    </div>
  );
};
